import React from "react";

import { Button, Small, Tooltip } from "@fronterahealth/frontera-ui-components";

import { ApiReportEhrSyncChoices } from "@api/graphql/types-and-hooks";

interface ProgrammingReviewHeaderProps {
  clientName: string;
  isEHROrgUser: boolean;
  assessmentReportId: string | null;
  ehrSyncStatus: ApiReportEhrSyncChoices | null | undefined;
  onSyncClick: () => void;
}

export const ProgrammingReviewHeader: React.FC<ProgrammingReviewHeaderProps> = ({
  clientName,
  isEHROrgUser,
  assessmentReportId,
  ehrSyncStatus,
  onSyncClick,
}) => {
  const isSyncCompleted = ehrSyncStatus === ApiReportEhrSyncChoices.Completed;
  const isSyncInProgress = ehrSyncStatus === ApiReportEhrSyncChoices.Inprogress;
  const isSyncDisabled = isSyncCompleted || isSyncInProgress;

  const getDisabledReason = () => {
    if (isSyncCompleted) return "Sync has already been completed";
    if (isSyncInProgress) return "Sync is currently in progress";
    return "";
  };

  const renderSyncButton = () => {
    const button = (
      <Button
        text="Sync to EHR"
        appearance="primary"
        className="py-2! px-4!"
        onClick={onSyncClick}
        disabled={isSyncDisabled}
      />
    );

    if (isSyncDisabled) {
      return (
        <Tooltip text={getDisabledReason()} showInfoIcon={false}>
          <span>{button}</span>
        </Tooltip>
      );
    }

    return button;
  };

  return (
    <div className="flex w-full items-center justify-between px-2">
      <Small displayType="loud" colorType="primary" className="ph-no-capture">
        {clientName ? `${clientName}'s Programming Review` : "Programming Review"}
      </Small>
      {isEHROrgUser && assessmentReportId ? renderSyncButton() : null}
    </div>
  );
};
